import React from 'react';
import LoadMore from "../common/LoadMore";
import TagsListItem from "./TagsListItem";
import FormatDate from "../common/FormatDate";
import MetaInfo from "../common/MetaInfo";
import UsersNameDisplay from "../users/UsersNameDisplay";
import { useQueryWithLoadMore } from "@/components/hooks/useQueryWithLoadMore";
import { gql } from "@/lib/generated/gql-codegen";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const SunshineTagFragmentMultiQuery = gql(`
  query multiTagNewTagsListQuery($selector: TagSelector, $limit: Int, $enableTotal: Boolean) {
    tags(selector: $selector, limit: $limit, enableTotal: $enableTotal) {
      results {
        ...SunshineTagFragment
      }
      totalCount
    }
  }
`);

const styles = defineStyles("NewTagsList", (theme: ThemeType) => ({
  root: {
    ...theme.typography.commentStyle,
    marginBottom: 24,
    background: theme.palette.panelBackground.default,
    padding: 12,
    paddingTop: 2,
    boxShadow: theme.palette.boxShadow.default,
  },
  date: {
    width: 30,
    marginRight: 8
  },
  user: {
    marginRight: 12,
  },
  postCount: {
    marginRight: 12,
  },
  loadMore: {
    marginLeft: 2,
    marginTop: 6
  }
}))

const NewTagsList = ({showHeaders = true}: {
  showHeaders?: boolean
}) => {
  const classes = useStyles(styles);
  const { data, loadMoreProps } = useQueryWithLoadMore(SunshineTagFragmentMultiQuery, {
    variables: {
      selector: { newTags: {} },
      limit: 4,
      enableTotal: true,
    },
    itemsPerPage: 20,
  });

  const results = data?.tags?.results;

  return <div className={classes.root}>
    {showHeaders && <h2>New Wikitags</h2>}
    <table>
      <tbody>
        {results?.map(tag => <tr key={tag._id}>
          {tag.user && <td className={classes.user}>
            <MetaInfo>
              <UsersNameDisplay user={tag.user}/>
            </MetaInfo>
          </td>}
          <td>
            <TagsListItem tag={tag}/>
          </td>
          <td>
            <MetaInfo>
              <FormatDate date={tag.createdAt}/>
            </MetaInfo>
          </td>
        </tr>)}
      </tbody>
    </table>
    <div className={classes.loadMore}>
      <LoadMore {...loadMoreProps}/>
    </div>
  </div>
}

export default NewTagsList



